import React from 'react'

import {
  Body2,
  BorderStyle,
  Box,
  Button,
  ButtonColorVariant,
  ButtonSize,
  Color,
  Display,
  FlexDirection,
  Heading4,
  Space,
} from '@gousto-internal/citrus-react'

import { CONTROL_VIEW_CTAS, ControlViewCtaIntent } from './controlViewCtas.data'

type ControlViewCtasProps = {
  onActionClick: (intent: ControlViewCtaIntent) => void
}

export const ControlViewCtas = ({ onActionClick }: ControlViewCtasProps) => (
  <Box
    data-testid="control-view-ctas"
    display={Display.Flex}
    flexDirection={[FlexDirection.Column, null, FlexDirection.Row]}
    gap={4}
  >
    {CONTROL_VIEW_CTAS.map((cta) => (
      <Box
        key={cta.action.intent}
        flexBasis="0"
        flexGrow={1}
        bg={Color.White}
        borderWidth={0.5}
        borderColor={Color.ColdGrey_100}
        borderStyle={BorderStyle.Solid}
        paddingV={6}
        paddingH={6}
        display={Display.Flex}
        flexDirection={FlexDirection.Column}
      >
        {/* Text grows to fill the equal-height card so the button always sits at the
            bottom — keeps the two CTAs' buttons aligned when subheadings differ in length. */}
        <Box flexGrow={1}>
          <Heading4 color={Color.ColdGrey_900}>{cta.heading}</Heading4>
          <Space size={2} />
          <Body2 color={Color.ColdGrey_700}>{cta.subheading}</Body2>
        </Box>
        <Space size={6} />
        <Button
          type="button"
          data-testid={`control-view-cta-${cta.action.intent}`}
          colorVariant={ButtonColorVariant.Primary}
          size={ButtonSize.Large}
          width="100%"
          onClick={() => onActionClick(cta.action.intent)}
        >
          {cta.action.label}
        </Button>
      </Box>
    ))}
  </Box>
)
